import { z } from 'zod/v3';

// ============================================================================
// 공통 Enum 스키마
// ============================================================================

/** 정렬 타입 */
export const categorySortTypeSchema = z.enum([
  'SCORE',
  'DISPLAY_RANK',
  'LOW_PRICE',
  'LATEST_PRODUCTS',
]);
export type CategorySortType = z.infer<typeof categorySortTypeSchema>;

// ============================================================================
// Category Model 스키마 (재귀)
// ============================================================================

/**
 * 전시 카테고리 트리 스키마
 * @description children 필드로 자기 자신을 참조하는 재귀 구조
 * @see GET /api/market-place/v1/display-categories
 */
export interface DisplayCategoryTree {
  /** 하위 카테고리 목록 */
  children: DisplayCategoryTree[];
  /** 카테고리 코드 */
  code?: string;
  /** 생성일 (KST) */
  createdAtKst?: string;
  /** 카테고리 깊이 */
  depth: number;
  /** 전시 순서 */
  displayOrder: number;
  /** 전체 경로명 */
  fullPathName?: string;
  /** 카테고리 ID */
  id?: number;
  /** 내부 카테고리 ID */
  internalCategoryId?: number;
  /** 활성화 여부 */
  isActive: boolean;
  /** 전시 여부 */
  isDisplayed: boolean;
  /** 리프 노드 여부 */
  isLeaf: boolean;
  /** 카테고리명 */
  name?: string;
  /** 오퍼 수 */
  offerCount: number;
  /** 상위 카테고리 ID */
  parentId?: number;
  /** 정렬 타입 */
  sortType?: CategorySortType;
  /** 수정일 (KST) */
  updatedAtKst?: string;
}

export const displayCategoryTreeSchema: z.ZodType<DisplayCategoryTree> = z.lazy(
  () =>
    z.object({
      /** 하위 카테고리 목록 */
      children: z.array(displayCategoryTreeSchema),
      /** 카테고리 코드 */
      code: z.string().optional(),
      /** 생성일 (KST) */
      createdAtKst: z.string().optional(),
      /** 카테고리 깊이 */
      depth: z.number(),
      /** 전시 순서 */
      displayOrder: z.number(),
      /** 전체 경로명 */
      fullPathName: z.string().optional(),
      /** 카테고리 ID */
      id: z.number().optional(),
      /** 내부 카테고리 ID */
      internalCategoryId: z.number().optional(),
      /** 활성화 여부 */
      isActive: z.boolean(),
      /** 전시 여부 */
      isDisplayed: z.boolean(),
      /** 리프 노드 여부 */
      isLeaf: z.boolean(),
      /** 카테고리명 */
      name: z.string().optional(),
      /** 오퍼 수 */
      offerCount: z.number(),
      /** 상위 카테고리 ID */
      parentId: z.number().optional(),
      /** 정렬 타입 */
      sortType: categorySortTypeSchema.optional(),
      /** 수정일 (KST) */
      updatedAtKst: z.string().optional(),
    }),
);
